import Vue from 'vue';
import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';

Vue.filter('formName', (formId: string) => {
	let subTitle = '';
	if (formId === '1fix' || formId === '1mobile') {
		subTitle = 'Форма 1';
	} else {
		subTitle = `Форма ${formId}`;
	}
	return subTitle;
});
Vue.filter('formatDate', (date: Date) => {
	const dt = new Date(date);
	return dt.toLocaleString('ru-RU').replace(',', '');

});
Vue.filter('formatDateOnly', (date: Date) => {
	const dt = new Date(date);
	return dt.toLocaleDateString();

});
Vue.filter('formatDateMonth', (date: Date) => {
	const dt = new Date(date);
	return format(dt, 'dd MMMM', { locale: ru });

});
Vue.filter('numberWithSign', (val: string) => {
	if (!val) {
		return val;
	}
	if (val === '0') {
		return val;
	} else if (val.startsWith('-')) {
		return val;
	} else {
		return `+${val}`;
	}
});
Vue.filter('numberBySpaces', (val: number) => {
	if (!val) {
		return val;
	}
	return val.toLocaleString();
});
